<template>

  <v-chip :class="{ 'w-100': full_with }" :label="label" :size="size" :color="computedPrioColor">
    <v-icon :size="16" :color="computedPrioColor">{{ selectedPrio.icon }}</v-icon>
    <span v-if="label" class="ml-2">{{ selectedPrio ? selectedPrio.name : "Onbekend" }}</span>
  </v-chip>

</template>

<script>
export default {
  name: "PriorityChip",
  props: {
    selected: { type: String, required: true },
    full_with: { type: Boolean, default: false },
    size: { type: String, default: "default" },
    type: { type: String, default: "chip" },
    label: { type: Boolean, default: true },
  },
  data: () => ({
    prios: [
      { id: 0, value: "none", name: "Geen", color: "#bbbbbb", icon: "fas fa-flag" },
      { id: 1, value: "low", name: "Laag", color: "#bbbbbb", icon: "fas fa-flag" },
      { id: 2, value: "normal", name: "Normaal", color: "#3e63dd", icon: "fas fa-flag" },
      { id: 3, value: "high", name: "Hoog", color: "#ffc53d", icon: "fas fa-flag" },
      { id: 4, value: "urgent", name: "Kritiek", color: "#c62a2f", icon: "fas fa-flag" },
    ],
  }),
  computed: {
    selectedPrio() {
      if (!this.selected) {
        return [];
      }
      return this.prios.find(prio => prio.value === this.selected);
    },
    computedPrioColor() {
      return this.selectedPrio ? this.selectedPrio.color : "#ccc";
    },
  },
};
</script>

<style>
.prio-chip {
  border-radius: 8px;
  text-align: center;
  width: auto;
  padding: 8px 4px;
  margin: auto;
  display: inline-block;
}

.prio-chip-inner {
  border-radius: 8px;
}

.chip-w-100 .prio-chip,
.chip-w-100.prio-chip {
  display: block;
}
</style>
